import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            了解我们
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            {aboutInfo.title}
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-10 max-w-[700px] mx-auto text-center">
            {aboutInfo.content}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {aboutInfo.stats.map((stat, index) => (
              <div key={index} className="text-center bg-background-50 rounded-xl py-5 px-3">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-600">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 flex items-center justify-center gap-2">
            <div className="w-2 h-2 rounded-full bg-primary-500"></div>
            <div className="w-2 h-2 rounded-full bg-accent-500"></div>
            <div className="w-2 h-2 rounded-full bg-secondary-500"></div>
            <span className="text-xs text-foreground-500 ml-2">用心做好每一条内容</span>
          </div>
        </div>
      </div>
    </section>
  );
}